import $ from 'jquery'

const initAccountEntryModal = ($dom) => {
  $dom.find("[data-behaviour='account-entries-modal']").each((index, el) => {
    el.addEventListener('click', () => {
      const modalParams = {
        totalValue: el.dataset.value,
        periodName: el.dataset.periodName,
        ledgerId: el.dataset.ledgerId,
        includeZerosValue: el.dataset.includeZerosValue,
        ranges: JSON.parse(el.dataset.ranges),
        addRoundingDifference: el.dataset.addRoundingDifference,
        unit: el.dataset.unit,
        precision: el.dataset.precision,
        analyticalDimensionId: el.dataset.analyticalDimensionId,
      }

      window.modalCitizen.openModal('account-entries-modal', modalParams)
    })
  })
}

$(document).on('initAccountEntryModal', function (_event, el) {
  const $el = $(el)
  initAccountEntryModal($el)
})

onDomLoad(($dom) => {
  initAccountEntryModal($dom)
})
